export default function isPlural(array = [], text = '', postfix = 's') {
  if (Array.isArray(array) && array.length > 1) return text + postfix
  if (typeof array === 'number' && array > 1) return text + postfix
  if (typeof array === 'boolean' && array) return text + postfix

  return text
}
